export function pluralize(
  word: string,
  count: number,
  pluralForm?: string,
): string {
  if (count === 1) {
    return word; // Singular form
  }

  // Use the provided plural form if available, otherwise add 's'
  return pluralForm || `${word}s`;
}
